import PropTypes from "prop-types";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";

function FormField({ label, customInput, ...rest }) {
  return (
    <SuiBox mb={3}>
      {label &&
        <SuiBox ml={0.5} lineHeight={0} display="inline-block">
          <SuiTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {label}
          </SuiTypography>
        </SuiBox>}
      {customInput || <SuiInput {...rest} />}
    </SuiBox>
  );
}

FormField.defaultProps = {
  customInput: null,
};

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  customInput: PropTypes.node,
};

export default FormField;
